<template>
  <v-row
    dense
    align="center"
    style="background-color: white; overflow: hidden; max-height: 57px; min-height: 57px;"
  >
    <v-col
      class="pl-5"
      cols="auto"
      style="width: 200px !important;"
    >
      <v-img
        :src="require('@/assets/systemx_MAIN_Colour_Black.svg')"
        max-width="130px"
        max-height="100px"
        width="100%"
        height="100%"
        contain
      />
    </v-col>
    <v-spacer />
    <v-col
      class="text-center"
    >
      <span style="font-size: 32px; white-space: nowrap; ">{{ title }}</span>
    </v-col>
    <v-spacer />
    <v-col
      cols="auto"
    >
      <v-btn
        @click="redirectToSystemx"
        color="#f0f0f0"
        elevation="0"
      >
        CANCEL
      </v-btn>
    </v-col>
    <v-col
      cols="auto"
      class="pr-5"
    >
      <v-btn
        @click="submit"
        class="white--text"
        color="green"
        elevation="0"
      >
        SAVE
      </v-btn>
    </v-col>
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
  </v-row>
</template>

<script>
import PromptDialog from '@/components/PromptDialog.vue';
export default {
  name: 'PdfAdminHeader',
  components: { PromptDialog },
  props: {
    environment: {
      type: String,
      default: '',
    },
    title: {
      type:String,
      default: '',

    },
    packageName:{
      type:String,
      default: '',
    },
  },
  data()  {
    
    return {
      serverPrefix: process.env.VUE_APP_SERVER_PREFIX,
      serverAddress: process.env.VUE_APP_SERVER_ADDRESS,
      
    };
  },
  computed: {},
  methods: {
    async redirectToSystemx() {
      const confirm = await this.$refs.promptDialog.open({
        message: 'It appears that the document has not been saved. If you leave this page, any unsaved changes will be lost. Are you certain that you want to proceed?',
      });
      if (!confirm) return;
      window.location.replace(
        `${this.serverPrefix}${this.environment}.${this.serverAddress}/sign`
      );
    },

    submit()
    {
      this.$emit('submit');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
